<div class="custom-scrollbar-css">
  <h2 class="modal-title" style="margin-top: 3%; margin-left: 65px; font-weight: bold;">

    Configuration d'alarme de manoeuvre </h2>

  <div class="container-fluid mt-3">

    <mat-horizontal-stepper>

      <form class="mt-4" [formGroup]="registerForm" (submit)="submitForm()">
        <mat-step label="Alarmes sur évènements "  >
          <div>
            <div class="row">

              <div class="col-6 col-md-12 w-100">
                <h1 class="p-2 " style="border-bottom: 1px solid #d5cccc;">

                  Niveau
                </h1>

                 <div class="row d-flex  justify-content-start form-group  ">
                  <mat-radio-group class="example-radio-button fif" formControlName="level">

                    <div class="pad">
                      <span class="span-form fif"> Compagnie </span>
                      <mat-radio-button class="example-radio-button fif" [value]=1>
                        <div class="EnableDiv" style="margin-top: 5%;">
                          <mat-form-field appearance="fill" class="example-full-width appearance-fill w-100 mb-3">
                              <!-- <mat-label>Compagnie</mat-label> -->
                              <input matInput #input value="{{name}}">
                            </mat-form-field>
                          </div>
                      </mat-radio-button>
                    </div>


                    <div class="pad">
                      <span class="span-form fif"> Véhicule </span>
                      <mat-radio-button class="example-radio-button fif" [value]=0 >
                        <app-units (selectdUnits)="setEntityIDVEh($event)"></app-units>
                      </mat-radio-button>
                    </div>
                  </mat-radio-group>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-6 col-md-12 w-100">
                <h1 class="p-2 " style="border-bottom: 1px solid #d5cccc;">


                  Manoeuvres
                </h1>


                <div class="row">
                  <div class="col-6 col-md-6 w-100">
                    <div class="row">

                      <div class="col-12">
                        <mat-form-field appearance="fill"
                          class="w-100 mb-3 appearance-fill" style="width: 50%;">
                          <mat-label>Seuil d'Accélération</mat-label>
                          <input type="number" matInput #input formControlName="acceleration" [(ngModel)]="acceleration"
                            [min]="minValue" [max]="maxValue"  [errorStateMatcher]="matcher">
                            <button mat-icon-button matSuffix >
                              <mat-icon>percent</mat-icon>
                            </button>
                          <mat-error *ngIf="registerForm.get('acceleration').hasError('max')" class="error-txt">Cette
                            valeur doit être inclue entre 0 et 100</mat-error>
                        </mat-form-field>
                      </div>
                     <!--  <div class="col-md-1" style="padding: 12px;">
                        <img width="25px" height="25px"
                          src="data:image/svg+xml;base64,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" />
                      </div> -->

                    </div>


                    <div class="row">

                      <div class="col-12">
                        <mat-form-field appearance="fill"
                          class="example-full-width appearance-fill w-100 mb-3" >
                          <mat-label>Seuil de Virage</mat-label>

                          <input type="number" matInput #input formControlName="turn" [(ngModel)]="virage"
                            [min]="minValue" [max]="maxValue"  [errorStateMatcher]="matcher">
                            <button mat-icon-button matSuffix >
                              <mat-icon>percent</mat-icon>
                            </button>
                          <mat-error *ngIf="registerForm.get('turn').hasError('max')" class="error-txt">Cette
                            valeur doit être inclue entre 0 et 100</mat-error>
                        </mat-form-field>
                      </div>
                      <!-- <div class="col-md-1" style="padding: 12px;">
                        <img width="25px" height="25px"
                          src="data:image/svg+xml;base64,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" />
                      </div> -->

                    </div>

                    <div class="row">

                      <div class="col-12">
                        <mat-form-field appearance="fill"
                          class="example-full-width appearance-fill w-100 mb-3" >
                          <mat-label>Seuil de Virage et freinage</mat-label>
                          <input type="number" matInput #input formControlName="turn_and_brake"
                            [(ngModel)]="virage_freinage" [min]="minValue" [max]="maxValue" [errorStateMatcher]="matcher">
                            <button mat-icon-button matSuffix >
                              <mat-icon>percent</mat-icon>
                            </button>
                          <mat-error *ngIf="registerForm.get('turn_and_brake').hasError('max')" class="error-txt">Cette
                            valeur doit être inclue entre 0 et 100</mat-error>
                        </mat-form-field>
                      </div>
                      <!-- <div class="col-md-1" style="padding: 12px;">
                        <img width="25px" height="25px"
                          src="data:image/svg+xml;base64,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" />
                      </div> -->

                    </div>


                    <div class="row">

                      <div class="col-12">
                        <mat-form-field appearance="fill"
                          class="example-full-width appearance-fill w-100 mb-3" >
                          <mat-label>Seuil d'Excès de vitesse:'</mat-label>
                          <input type="number" matInput #input formControlName="speeding" [(ngModel)]="exces_vitesse" [min]="minValue"
                            [max]="maxValue"  [errorStateMatcher]="matcher">
                            <button mat-icon-button matSuffix >
                              <mat-icon>percent</mat-icon>
                            </button>
                          <mat-error *ngIf="registerForm.get('speeding').hasError('max')" class="error-txt">Cette
                            valeur doit être inclue entre 0 et 100</mat-error>
                        </mat-form-field>
                      </div>


                    </div>


                  </div>
                  <div class="col-6 col-md-6 w-100">
                    <div class="row">

                      <div class="col-12 ">
                        <mat-form-field appearance="fill"
                          class="example-full-width appearance-fill w-100 mb-3" >
                          <mat-label>Seuil de Freinage:</mat-label>
                          <input type="number" matInput #input formControlName="braking" [(ngModel)]="freinage" [min]="minValue"
                            [max]="maxValue"  [errorStateMatcher]="matcher">
                            <button mat-icon-button matSuffix >
                              <mat-icon>percent</mat-icon>
                            </button>
                          <mat-error *ngIf="registerForm.get('braking').hasError('max')" class="error-txt">Cette
                            valeur doit être inclue entre 0 et 100</mat-error>
                        </mat-form-field>
                      </div>


                    </div>


                    <div class="row">

                      <div class="col-12">
                        <mat-form-field appearance="fill"
                          class="example-full-width appearance-fill w-100 mb-3" >
                          <mat-label>Seuil de Virage et Accélération:</mat-label>
                          <input type="number" matInput #input formControlName="turn_and_accelerate" [(ngModel)]="virage_acceleration"
                            [min]="minValue" [max]="maxValue"  [errorStateMatcher]="matcher">
                            <button mat-icon-button matSuffix >
                              <mat-icon>percent</mat-icon>
                            </button>
                          <mat-error *ngIf="registerForm.get('turn_and_accelerate').hasError('max')" class="error-txt">Cette
                            valeur doit être inclue entre 0 et 100</mat-error>
                        </mat-form-field>
                      </div>


                    </div>
                    <div class="row">

                      <div class="col-12">
                        <mat-form-field appearance="fill"
                          class="example-full-width appearance-fill w-100 mb-3" >
                          <mat-label>Seuil de Franchissement de ligne:</mat-label>
                          <input type="number" matInput #input formControlName="lane_crossing" [(ngModel)]="franchissement_ligne"
                            [min]="minValue" [max]="maxValue"  [errorStateMatcher]="matcher">
                            <button mat-icon-button matSuffix >
                              <mat-icon>percent</mat-icon>
                            </button>
                          <mat-error *ngIf="registerForm.get('lane_crossing').hasError('max')" class="error-txt">Cette
                            valeur doit être inclue entre 0 et 100</mat-error>
                        </mat-form-field>
                      </div>


                    </div>



                  </div>
                </div>







              </div>



            </div>



          </div>
        </mat-step>
      <!--   <mat-step label="Périodes planifiées" state="chat"  >
          <div class="row">

            <div class="col-6 col-md-12 w-100">
              <h1 class="p-2 ">
                <img width="25px" height="25px"
                  src="data:image/svg+xml;base64,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" />
                Périodes planifiées
              </h1>
              <mat-radio-group aria-label="Select an option">
                <div class="row" style="padding: 12px;  ">

                  <div class="col-md-12">
                    <mat-radio-button (click)="alarm_tjrs_active()" value="1">Alarmes toujours actives
                    </mat-radio-button>

                  </div>


                </div>
                <div class="row" style="padding: 12px;  ">

                  <div class="col-md-12">
                    <mat-radio-button (click)="alarm_active_tranches()" value="2">Alarmes actives par tranches horaires
                    </mat-radio-button>

                  </div>


                </div>

              </mat-radio-group>
              <div class="row">
                <div class="col-12 w-100 ">



                </div>
              </div>
            </div>


          </div>
        </mat-step> -->
        <mat-step label="Notifications" >
          <div class="row">

            <div class="col-6 col-md-12 w-100">
              <h1 class="p-2 ">

                Notifications
              </h1>

              <div class="row">
                <div class="col-md-2">
                </div>
                <div class="col-md-10">

                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-11 w-100">
                      <!--  <mat-form-field appearance="fill" style="width: 100%; margin-bottom: 20px;">
                        <mat-label>Rechercher contact</mat-label>
                        <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
                        <mat-icon matSuffix>search</mat-icon>
                      </mat-form-field> -->

                      <form>
                        <mat-form-field appearance="fill" style="width: 100%; margin-bottom: 20px;"
                          (click)="hiddencontenu()" class="appearance-fill">
                          <mat-label>Sélectionner un contact déjà existant </mat-label>
                          <!--(keyup)="applyFilterer($event)"-->
                          <input type="text" aria-label="Number" matInput (keyup)="applyFilter1($event)"
                            (click)="hiddencontenu2()" [formControl]="myControl" [matAutocomplete]="auto" />



                          <button mat-button matSuffix mat-icon-button>
                            <mat-icon placement="bottom" ngbTooltip="Actualiser la liste des contacts"
                              (click)="refrech()">refresh
                            </mat-icon>

                          </button>
                          <button mat-button matSuffix mat-icon-button (click)="hiddencontenu()">
                            <mat-icon placement="bottom" ngbTooltip="Lister les contacts">filter_list</mat-icon>

                          </button>


                          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">


                            <table class="table-hover" mat-table [dataSource]="dataSourcet">
                              <!-- Position Column -->
                              <ng-container matColumnDef="position">
                                <th mat-header-cell *matHeaderCellDef>Contact.</th>
                                <td (click)="getContact_notif()" mat-cell *matCellDef="let elementt" [ngClass]="{
                                    highlight: selectedRowIndex2 == elementt.id
                                  }" (click)="getItemDetails2(elementt)">
                                  <strong> Name: {{ elementt.first_name }} </strong> <br />
                                  Id: {{ elementt.id }} <br />

                                  Email: {{ elementt.email }}
                                </td>
                              </ng-container>

                              <tr class="d-none" mat-header-row *matHeaderRowDef="displayedColumnst"></tr>
                              <tr mat-row *matRowDef="let elementt; columns: displayedColumnst"></tr>
                            </table>


                            <mat-option class="d-none"> </mat-option>
                          </mat-autocomplete>
                        </mat-form-field>
                      </form>

                    </div>
                    <div class="col-md-1 w-100" >
                      <img data-toggle="collapse" (click)="add_contact()" data-target="#collapseMalasngoding"
                        aria-expanded="false" aria-controls="collapseMalasngoding" style="height: 85%;"
                        placement="left" ngbTooltip="Ajouter un nouveau contact"
                        src="assets/icons/addcontact.svg" />
                    </div>
                  </div>
                  <div class="collapse" id="collapseMalasngoding">
                    <!--       <mat-radio-group aria-label="Select an option" >
                        <div class="row" style=" margin-bottom: 15px;">
                            <div class="col-md-4">
                            </div>
                       <div class="col-md-3">
                                <mat-radio-button  (click)="select_contact()" value="1">Sélectionner un contact existant
                                </mat-radio-button>

                            </div>
                          <div class="col-md-4">
                                <mat-radio-button (click)="add_contact()" value="2">Créer un nouveau contact</mat-radio-button>

                            </div>
                            <div class="col-md-4">
                            </div>
                        </div>
                        </mat-radio-group> -->
                    <div class="row">
                      <div class="col-md-4">

                      </div>
                      <div class="col-md-4">




                        <!--    <form>
                            <mat-form-field appearance="fill" (click)="hiddencontenu()">
                              <mat-label>Filtrer par contact</mat-label>

                              <input type="text" aria-label="Number"  matInput (keyup)="applyFilter1($event)" (click)="hiddencontenu2()"
                                [formControl]="myControl" [matAutocomplete]="auto" />



                              <button mat-button matSuffix mat-icon-button>
                                <mat-icon matTooltip="Actualiser les données des véhicules " (click)="refrech()">refresh</mat-icon>

                              </button>
                              <button mat-button  matSuffix mat-icon-button (click)="hiddencontenu()">
                                <mat-icon matTooltip="Liste vehicule">filter_list</mat-icon>

                              </button>


                              <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">


                                <table class="table-hover" mat-table [dataSource]="dataSourcet">

                                  <ng-container matColumnDef="position">
                                    <th mat-header-cell *matHeaderCellDef>Contact.</th>
                                    <td (click)="getContact_notif()" mat-cell *matCellDef="let elementt" [ngClass]="{
                                        highlight: selectedRowIndex2 == elementt.id
                                      }" (click)="getItemDetails2(elementt)">
                                      <strong> Name: {{ elementt.first_name }} </strong> <br />
                                      Id: {{ elementt.id }} <br />

                                      Email: {{ elementt.email }}
                                    </td>
                                  </ng-container>

                                  <tr class="d-none" mat-header-row *matHeaderRowDef="displayedColumnst"></tr>
                                  <tr mat-row *matRowDef="let elementt; columns: displayedColumnst"></tr>
                                </table>

                                <mat-paginator #secondPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>

                                <mat-option class="d-none"> </mat-option>
                              </mat-autocomplete>
                            </mat-form-field>
                          </form> -->



                        <mat-form-field *ngIf="new_contact == false" appearance="fill"
                          style=" width: 100%; margin-bottom: 20px;" class="appearance-fill">
                          <mat-label>Contacts</mat-label>
                          <mat-select [formControl]="contacts">
                            <mat-option *ngFor="let contact of contactList" [value]="contact">{{contact.first_name}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="col-md-4">

                      </div>
                    </div>
                    <form class="mt-4" [formGroup]="registerFormContact" (submit)="submitcontact()">
                      <div class="row" *ngIf="new_contact == true">
                        <div class="col-md-6" style=" margin-bottom: 20px;">
                          <mat-form-field class="example-full-width appearance-fill" appearance="fill" style="width: 100%;">
                            <mat-label>Nom</mat-label>
                            <input matInput formControlName="last_name" required  [errorStateMatcher]="matcher">
                            <mat-error *ngIf="registerFormContact.get('last_name').hasError('pattern')">Veuillez saisir
                              une format valide !
                            </mat-error>
                            <mat-error *ngIf="registerFormContact.get('last_name').hasError('required')">
                              Nom est <strong>Obligatoire</strong>
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col-md-6" style=" margin-bottom: 20px;">
                          <mat-form-field class="example-full-width appearance-fill" appearance="fill" style="width: 100%;">
                            <mat-label>Prénom</mat-label>
                            <input matInput formControlName="first_name" required  [errorStateMatcher]="matcher">
                            <mat-error *ngIf="registerFormContact.get('first_name').hasError('pattern')">Veuillez saisir
                              une format valide !
                            </mat-error>
                            <mat-error *ngIf="registerFormContact.get('first_name').hasError('required')">
                              Prénom est <strong>Obligatoire</strong>
                            </mat-error>
                          </mat-form-field>
                        </div>

                      </div>

                      <div class="row" *ngIf="new_contact == true">
                        <div class="col-md-6" style=" margin-bottom: 20px;">
                          <mat-form-field class="example-full-width appearance-fill" appearance="fill" style="width: 100%;">
                            <mat-label>Courrier électronique</mat-label>
                            <input matInput formControlName="email" required  [errorStateMatcher]="matcher">

                            <mat-error *ngIf="registerFormContact.get('email').hasError('email')">Veuillez saisir une
                              format valide !
                            </mat-error>
                            <mat-error *ngIf="registerFormContact.get('email').hasError('required')">
                              Email est <strong>Obligatoire</strong>
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col-md-6" style=" margin-bottom: 20px;">
                          <mat-form-field class="example-full-width appearance-fill" appearance="fill" style="width: 100%;">
                            <mat-label>Numéro de téléphone</mat-label>
                            <input matInput type="number" formControlName="gsm_number">
                          </mat-form-field>
                        </div>

                      </div>
                    </form>
                    <mat-icon placement="bottom" ngbTooltip="Confirmer" (click)="submitcontact()"
                    *ngIf="new_contact == true && registerFormContact.valid"
                    style="color: #031f3d; margin-left: 96%;
                    margin-top: -1%;">check_circle_outline</mat-icon>
                    <!-- <img placement="bottom" ngbTooltip="Confirmer" (click)="submitcontact()"
                    *ngIf="new_contact == true && registerFormContact.valid" width="40px" height="40px"
                    src="https://img.icons8.com/ios/64/4a90e2/ok--v1.png"
                     style="margin-left: 96%;
                     margin-top: -1%;"/> -->
                  </div>
                  <table mat-table [dataSource]="dataSourceC" class="mat-elevation-z8">

                    <!--- Note that these columns can be defined in any order.
                            The actual rendered columns are set as a property on the row definition" -->


                    <!-- Checkbox Column -->
                    <ng-container matColumnDef="select">
                      <th mat-header-cell *matHeaderCellDef>

                      </th>

                      <td (click)="selection.toggle(element)" mat-cell *matCellDef="let element" formArrayName="key">
                        <mat-checkbox (click)="$event.stopPropagation()"
                          (change)="$event ? selection.toggle(element) : null" [checked]="selection.isSelected(element)"
                          [aria-label]="checkboxLabel(element)" [formControlName]="element">
                        </mat-checkbox>
                      </td>
                    </ng-container>

                    <!-- ID Column -->
                    <ng-container matColumnDef="id">
                      <th mat-header-cell *matHeaderCellDef> ID. </th>
                      <td mat-cell *matCellDef="let element"> {{element.id}} </td>
                    </ng-container>

                    <!-- Prénom Column -->
                    <ng-container matColumnDef="first_name">
                      <th mat-header-cell *matHeaderCellDef> Prénom </th>
                      <td mat-cell *matCellDef="let element"> {{element.first_name}} </td>
                    </ng-container>

                    <!-- Nom Column -->
                    <ng-container matColumnDef="last_name">
                      <th mat-header-cell *matHeaderCellDef> Nom </th>
                      <td mat-cell *matCellDef="let element"> {{element.last_name}} </td>
                    </ng-container>

                    <!-- delete Column -->
                    <ng-container matColumnDef="delete">
                      <th mat-header-cell *matHeaderCellDef> Actions </th>
                      <td mat-cell *matCellDef="let element ; let i= index" style="justify-content: end;">
                        <img (click)="Delete_contact(i)" placement="left" ngbTooltip="Supprimer contact"src="assets/icons/icon-delete.svg" />

                      </td>
                    </ng-container>

                    <!-- email Column -->
                    <ng-container matColumnDef="email">
                      <th mat-header-cell *matHeaderCellDef> email </th>
                      <td mat-cell *matCellDef="let element"> {{element.email}} </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </mat-step>

        <!-- Icon overrides. -->
        <ng-template matStepperIcon="phone">
          <mat-icon>notifications</mat-icon>
        </ng-template>
        <ng-template matStepperIcon="chat">
          <mat-icon>schedule</mat-icon>
        </ng-template>
        <ng-template matStepperIcon="notif">
          <mat-icon>notifications_active</mat-icon>
        </ng-template>
      </form>
    </mat-horizontal-stepper>
  </div>
</div>

<!-- <form [formGroup]="registerFormContact2">

  <button (click)="submitcontact2()">test</button>
</form> -->

<div class=" justify-content-end d-flex" style="margin-right: 2%; margin-bottom: 40px;">
  <a [ngClass]="{colorIconActive : registerForm.valid    ,colorIconInactive : !registerForm.valid   }"
    class="savebtn mr-2" type="submit" (click)="submitForm()">Enregistrer</a>

  <a class="cancelbtn mr-2" type="submit" aria-pressed="true" (click)="onNoClick()">Annuler</a>
</div>

<!-- <div class=" justify-content-end d-flex" style="margin-right: 5%; margin-bottom: 40px;">
  <a class="savebtn mr-2" type="submit" [ngClass]="{'disabled': !registerForm.valid }"  (click)="submitForm()">Sauvegarder</a>
  <a class="cancelbtn mr-2" type="submit" (click)="onNoClick()">Annuler</a>
</div> -->
